<template>
<v-app class="survey-container">

    <v-layout class="bg-light-blue" row wrap>
      <v-flex xs12>
        <NavBarHome></NavBarHome>

        <div class="content">
          <h1>Page Unavailable</h1>

          <p class="content-detail">
            This function is not available during the Pretest.  Click "Back" to return to the Homepage.
          </p>

          <br/>

          <v-btn normal class="blue-button" @click="back">
            <v-icon>mdi-arrow-left</v-icon>
            Back</v-btn>

        </div>
      </v-flex>
    </v-layout>

    <Footer></Footer>
     
</v-app>
</template>


<script>
// @ is an alias to /src
import Vue from 'vue';
import router from '@/router';
import { NavBarHome } from '@/components/NavBarHome.vue';
import { footer } from '@/components/Footer.vue';
export default {
  name: 'Unavailable_',
  props: {
  },
  data: () => ({
    prevRoute: null,
  }),
  watch: {
  },
  mounted () {
    const me = this;
  },
  methods: {
    // WIP - really want this to go back up one level or back to home page only when one level down (TODO)
    back () {
      //console.log(JSON.stringify(this.$router.go(-1)));
      //this.$router.go(-1);
      this.$router.push({ name: 'home' });
    }
  },
  // data() {
//  return {
//    ...
//    prevRoute: null
//  }
// },
// beforeRouteEnter(to, from, next) {
//   next(vm => {
//     vm.prevRoute = from
//   })
// },
  computed: {
  },
}
</script>

<style scoped>
.survey-container  {
  width: 100%;
  margin: 0 auto;
}
.content {
  padding: 3% 3% 3% 5%;
  text-align: left;
}
.content-header {
  font-weight: bold;
}
.content-detail {
  font-weight: normal;
}
.v-text-field >>> input {
  text-align: left;
  padding: 3px;
  min-width: 150px;
}
h1 {
  margin: 20px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-size: 20pt;
  font-style: normal;
  font-weight: bold;
}
h2 {
  font-size: 16pt;
  font-weight: normal;
}
h3 {
  font-size: 14pt;
  font-weight: normal;
  color: #c55911;
}
a {
  font-weight: bold;
}
</style>
